import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs';
import {SharedImports} from '@shared/shared-imports';
import {ContextService} from '@services/context.service';
import {StepperModule} from 'primeng/stepper';
import {takeUntil} from 'rxjs/operators';
import {RegistrationPage5ConfirmComponent} from '@app/public/user-registration-custom/registration-page-5-confirm/registration-page-5-confirm.component';
import {RegistrationPage4AddressComponent} from '@app/public/user-registration-custom/registration-page-4-address/registration-page-4-address.component';
import {RegistrationPage3BillingComponent} from '@app/public/user-registration-custom/registration-page-3-billing/registration-page-3-billing.component';
import {RegistrationPage1ContactComponent} from '@app/public/user-registration-custom/registration-page-1-contact/registration-page-1-contact.component';
import {OrganizationService} from '@services/organizations.service';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';
import {RegistrationPage2SecurityComponent} from '@app/public/user-registration-custom/registration-page-2-security/registration-page-2-security.component';

@Component({
  templateUrl: './user-registration-custom.component.html',
  styleUrls: ['./user-registration-custom.component.scss'],
  imports: [SharedImports, StepperModule, RegistrationPage5ConfirmComponent, RegistrationPage4AddressComponent, RegistrationPage3BillingComponent, RegistrationPage1ContactComponent, RegistrationPage2SecurityComponent]
})
export class PublicUserRegistrationCustomComponent implements OnInit, OnDestroy, AfterViewInit {
  logo: string;
  tenant: string;
  active: number | undefined = 1;
  organizationId: string;
  organization: OrganizationRegistrationModel;
  dataLoaded: boolean = false;
  stepOneComplete: boolean = false;
  stepTwoComplete: boolean = false;
  stepThreeComplete: boolean = false;
  stepFourComplete: boolean = false;
  tenantAllowsRegistrationPayment: boolean = false;
  registrationProfile = {} as SelfRegistrationModel;
  // orgCampaignDetails = {} as SOICampaignModel;
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private organizationService: OrganizationService,
              private contextService: ContextService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: (params) => {
        // get the query parameters
        if (params && params.tenant) {
          this.tenant = params.tenant;
        } else {
          this.tenant = null;
        }
        this.organizationId = this.route.snapshot.paramMap.get('id');
        this.logo = this.contextService.contextObject.tenantLogo;
        //window.location.replace('public/email-verification/registration/' + this.organizationId + '?tenant=' + this.tenant);
        // this.tenantAllowsSelfRegistration = this.tenantConfigDataService.getBooleanValue('ALLOWSELFREGISTER');
      }
    });
  }

  ngAfterViewInit() {
    this.organizationService.getOrganizationRegistrationData(this.organizationId, this.tenant)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.organization = res;
          this.tenantAllowsRegistrationPayment = res.PaymentRequired;
          this.registrationProfile.OrganizationID = res.OrganizationId;
          this.registrationProfile.TenantName = this.tenant;
        }, error: (e) => {
          this.dataLoaded = true;
          console.debug(e);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
